<template>
  <div class="mb-lg">
    <div class="task_item item-3 round-8 bg-primary shadow-1">
      <div class="right pl-md">
        <span class="item_title text-primary text-bold">任务四:</span>
        <wd-img class="mt-sm" width="40" :src="taskHeadMusic"></wd-img>
      </div>
      <div class="center mt-md mr-md">
        <div class="item-center-title text-bold">上传音乐</div>
        <div class="item-center-content">获得5次福利机会+3G全国通用流量</div>
      </div>
      <div class="left mr-md">
        <wd-button v-if="!$store.getters['User/user'].appUser.musicWish" @click="isShow = true"
                   class="item-action bg-primary-linear-gradient">上传领取
        </wd-button>
        <wd-button v-else-if="$store.getters['User/user'].appUser.musicFlow"
                   class="item-action bg-primary-linear-gradient">已领取
        </wd-button>
        <wd-button v-else class="item-action bg-primary-linear-gradient" @click="getFlow">点击领取</wd-button>
      </div>
    </div>
    <wd-popup v-model="isShow"
              class="lotto-popup"
              style=""
              :close-on-click-modal="false"
              @close="$store.commit('curtain/setShow',false)"
              closable
    >
      <div class="lotto-popup-content bg-all pa-lg round-16 mt-xxxl">
        <div class="title-img mb-lg">
          <wd-img width="100" :src="Music"/>
        </div>
        <div class="lotto-popup-content--title"></div>
        <div class="text-bold">
          上传音乐
        </div>
        <div class="upload-box">
          <input style="width: 0;height: 0" ref="file" type="file" @change="uploadPhoto()" accept="audio/*"/>
          <div class="upload-box-content" @click="fileInputClick">
            <wd-img width="60" :src="boxMusic"/>
            <div class="">
              <span>上传音乐</span>
            </div>
          </div>
        </div>
        <div class="upload-alert">
          <span>上传音乐，需小于100M</span>
        </div>
        <div class="upload-end-img">
          <wd-img width="140" :src="boxEnd"/>
        </div>
      </div>
    </wd-popup>
    <wd-popup v-model="showLoading"
              :close-on-click-modal="false"
              class="round-16 pa-lg" style="background-color: transparent;width: 60%">
      <div style="width: 100%;text-align: center">
        <wd-loading style="margin: 16px auto;"></wd-loading>
        <span style="color: white">{{ msg }}</span>
        <wd-progress hide-text :percentage="percentage"></wd-progress>
      </div>
    </wd-popup>
    <wd-popup v-model="getFlowLoading"
              :close-on-click-modal="false"
              class="round-16 pa-lg" style="background-color: transparent;width: 60%">
      <div style="width: 100%;text-align: center">
        <wd-loading style="margin: 16px auto;"></wd-loading>
        <span style="color: white">{{ '正在领取，请稍等' }}</span>
      </div>
    </wd-popup>
    <wd-popup v-model="showError" style="width: 80%;border-radius: 8px;"
              class="bg-white"
              :style="{ 'padding': '24px 8px' }" closable @close="showError = false">
      <div style="text-align: center;margin-bottom: 16px;font-weight: bold;color: #fb5946;font-size: 20px">领取失败</div>
      <div style="padding: 0 16px 0 16px">您的<span style="color: #2d8ff5"> {{ errorPhone }} </span>未开通VoLTE功能，请开通后领取
      </div>
      <div style="padding: 16px 16px 0 16px;color: #777">开通方式：编辑短信’42010‘发送至”10001“开通VoLte功能</div>
    </wd-popup>
  </div>

</template>

<script>
import {getFlow, uploadFileToTinaYi} from "@/api/tianyi/tianyi.api";
import {uploadCloudOpenFile} from "@/views/upload/api/uploadCloudOpenFile";
import {boxMusic, Music, taskHeadMusic, boxEnd} from "@/skin/skin";

export default {
  name: "UploadVideo",
  data() {
    return {
      boxMusic: boxMusic,
      Music: Music,
      taskHeadMusic: taskHeadMusic,
      boxEnd: boxEnd,
      isShow: false,
      showError: false,
      getFlowLoading: false,
      showLoading: false,
      percentage: 0,
      msg: '',
      errorPhone: ''
    }
  },
  methods: {
    open() {
      this.isShow = true
    },
    fileInputClick() {
      this.$refs.file.click()
    },
    uploadPhoto() {
      const fileMaxSize = 1048576 * 300
      if (this.$refs.file.files[0].size > fileMaxSize) {
        this.$toast.warning('文件大小不得超过1M！')
        return false
      }
      this.showLoading = true

      const file = this.$refs.file.files[0]
      uploadCloudOpenFile(file, this.$store.getters["User/token"], (e) => {
        this.percentage = e.progress
        this.msg = e.msg
        if (e.msg === '上传成功') {
          this.fileSuccess()
        }
      }, this.fileError)
    },
    fileSuccess() {
      this.msg = "上传完成，请稍等"
      let param = {
        token: this.$store.getters["User/user"].appUser.token,
        fileType: 'audio/*'
      }
      uploadFileToTinaYi(param).then(resp => {
        this.showLoading = false
        if (resp.code === 0) {
          this.$toast.success("上传成功")
          this.$store.dispatch("User/getUploadDetails", this.$store.getters["User/user"].appUser.token)
        } else {
          this.$toast.error(resp.msg)
        }
        this.$refs.file.value = ''
        this.isShow = false
      })
    },
    fileError(error) {
      this.$toast.error(error)
      this.$refs.file.value = ''
      this.isShow = false
      this.showLoading = false
    },
    getFlow() {
      this.getFlowLoading = true
      getFlow(this.$store.getters["User/user"].appUser.token, 'audio/*').then(resp => {
        if (resp.code === 0) {
          this.$toast.success(resp.msg)
        } else if (resp.code === 4444) {
          this.showError = true
          this.errorPhone = resp.msg
        } else {
          this.$toast.error(resp.msg)
        }
        this.$store.dispatch("User/getUploadDetails", this.$store.getters["User/user"].appUser.token).then(res => {
          this.getFlowLoading = false
        })
      })
    }

  }
}
</script>

<style scoped>

</style>
